module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-02-ee8bdb26eed277a3d52abc072090a4d7.jpg";